
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import DrawingCanvas from '@/components/atoms/DrawingCanvas.vue'
import { DrawingModel } from '@/models/DrawingModel'

/**
 * 手書きなどで作成したストローク情報を復元表示する
 */
@Component({
  components: {
    DrawingCanvas,
  },
})
export default class DrawStroke extends Vue {
  /** 描画済みのストローク情報 */
  @Prop()
  private strokes!: DrawingModel.Stroke[]

  /** canvasコンポーネントアクセス用ref */
  @Ref()
  private canvas!: DrawingCanvas

  /**
   * 初期処理
   */
  private mounted(): void {
    // キャンバスの再描画を行う
    this.drawAllStrokes()
  }

  /**
   * 描画処理を実行
   */
  public drawAllStrokes(): void {
    // キャンバスのクリア
    this.canvas.context.beginPath()
    this.canvas.context.clearRect(0, 0, this.canvas.element.width, this.canvas.element.height)

    // ストローク情報を描画
    this.strokes.forEach((stroke) => {
      this.drawStroke(stroke)
    })
  }

  /**
   * ストロークの描画を実行
   *
   * @param stroke ストローク情報
   */
  private drawStroke(stroke: DrawingModel.Stroke): void {
    // ペン情報の設定
    this.canvas.context.globalCompositeOperation = 'source-over'
    this.canvas.context.lineWidth = stroke.pen.lineWidth
    this.canvas.context.lineCap = stroke.pen.lineCap
    this.canvas.context.lineJoin = stroke.pen.lineJoin
    this.canvas.context.strokeStyle = stroke.pen.color

    // 描画開始
    this.canvas.context.beginPath()

    stroke.points.forEach((point, i) => {
      if (i === 0) {
        // 配列の先頭だけmoveToを使用する
        this.canvas.context.moveTo(point.x, point.y)
      } else {
        this.canvas.context.lineTo(point.x, point.y)
      }
    })

    // 線の出力
    this.canvas.context.stroke()
  }
}
